var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-container"},[_c('input',{ref:"file",staticClass:"upload-image",attrs:{"upload-icon":"plus","maxlength":_vm.maxNumber,"type":"file","name":"pic","accept":"image/*"},on:{"change":_vm.upload}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }